export default __webpack_public_path__ + "static/media/trash.83f075ca.svg";